<template>
  <div class="nodata" v-bind:style="{minHeight: minHight, margin:'0.42rem'}">
    <img src="@/assets/nodata_error.png">
    <div style="color:#333;">{{ title }}</div>
    <div style="color:#999;font-size:0.256rem;margin-top:0.42rem">{{ remark }}</div>
  </div>
</template>

<script>
export default {
  name: 'NoData',
  components: {
  },
  props: {
    title: {
      type: String,
      default: '暂无数据'
    },
    remark: {
      type: String,
      default: ''
    },
    minHight: {
      type: String,
      default: 'no'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
